"use client";

import { useState } from "react";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Cpu, Loader2 } from "lucide-react";
import { useRouter } from "next/navigation";
import { useAuth } from "../../../hooks/useAuth";

export default function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const { login } = useAuth();
  const router = useRouter();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");

    try {
      const response = await login({ username, password });

      if (response) {
        router.push("/chat-assist");
      } else {
        setError("Invalid username or password.");
      }
    } catch (err) {
      console.error("Login error:", err);
      setError("Failed to login. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-blue-900 to-purple-900 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white bg-opacity-10 backdrop-filter backdrop-blur-lg rounded-3xl p-8 shadow-2xl">
          <div className="flex justify-center mb-8">
            <div className="bg-blue-500 rounded-full p-3 relative">
              <Cpu className="w-8 h-8 text-white" />
              <div className="absolute inset-0 rounded-full bg-blue-500 animate-ping opacity-75"></div>
            </div>
          </div>
          <h1 className="text-2xl font-bold text-center text-white mb-6">
            Welcome to <strong>SupportPilotAI</strong>
          </h1>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="text-white">Username</Label>
              <Input
                placeholder="Enter your username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="mt-1 bg-white bg-opacity-30 border-0 text-white placeholder:text-white/90 focus:bg-white/40"
                required
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-white">
                Password
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="mt-1 bg-white bg-opacity-30 border-0 text-white placeholder:text-white/90 focus:bg-white/40"
                required
              />
            </div>
            {error && (
              <div className="p-3 rounded-lg bg-red-500/10 border border-red-500/20 text-red-500">
                {error}
              </div>
            )}
            <Button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                  Logging in...
                </>
              ) : (
                "Sign in"
              )}
            </Button>
          </form>
          {/* <p className="mt-8 text-center text-sm text-gray-300">
            Don't have an account?{' '}
            <Link href="/register" className="font-semibold text-blue-400 hover:text-blue-300">
              Sign up for free
            </Link>
          </p> */}
        </div>
      </div>
    </div>
  );
}
